import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const pointTypesAdapter = getAdapter({ idFieldName: 'value' });

const pointTypesSlice = createSlice({
  name: 'pointTypes',
  initialState: pointTypesAdapter.getInitialState(),
  reducers: {
    setPointTypes: (state, { payload: { pointTypes } }) => {
      pointTypesAdapter.setAll(state, pointTypes);
    },
  },
});

const selectors = pointTypesAdapter.getSelectors(({ pointTypes }) => pointTypes);

export const getAllPointTypes = (state) => selectors.selectAll(state);

export const {
  setPointTypes,
} = pointTypesSlice.actions;

export default pointTypesSlice.reducer;
